import service from '@/middleware'

const commandApi = {
    /**
     * Datos para la tabla del reporte de comandos enviados
     */
    async getSentCommandsReport (ids, from, to) {
        const body = {
            ids,
            from,
            to
        }
        const response = await service.http.post(
            `/api/command/sent-commands-report`, body)
        return response
    },

    /**
     * Envío de comandos (carga masiva)
     * @param {*} things
     * @param {*} commands
     * @param {*} forwardingInterval
     * @param {*} forwardingMaxAttemptTime
     */
    async sendCommandsMassiveUpload (things, commands, forwardingInterval, forwardingMaxAttemptTime) {
        const body = {
            things,
            commands,
            forwardingInterval,
            forwardingMaxAttemptTime
        }
        const response = await service.http.post(
            `/api/command/send-bulk-commands`, body)
        return response
    },

    /**
     * Datos actualizados del envío de comandos (carga masiva)
     * @param {*} commandIds
     */
    async getMassiveUploadData (commandIds) {
        const response = await service.http.post(
            `/api/command/commands-by-id`, commandIds)
        return response
    }
}

export default commandApi
